import { render, staticRenderFns } from "./jobInfo.vue?vue&type=template&id=c4a39d9a&scoped=true&"
import script from "./jobInfo.vue?vue&type=script&lang=js&"
export * from "./jobInfo.vue?vue&type=script&lang=js&"
import style0 from "./jobInfo.vue?vue&type=style&index=0&id=c4a39d9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a39d9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4a39d9a')) {
      api.createRecord('c4a39d9a', component.options)
    } else {
      api.reload('c4a39d9a', component.options)
    }
    module.hot.accept("./jobInfo.vue?vue&type=template&id=c4a39d9a&scoped=true&", function () {
      api.rerender('c4a39d9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/company/jobInfo.vue"
export default component.exports